export default {"src":"/_next/static/media/plain-terrain.170427bb.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};